export function noop() {}

export function formatDate(date: Date | string) {
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date(date));
}

export function formatCurrency(value: number, unitRequired = true) {
  const v = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'PKR',
  }).format(value);

  return unitRequired ? v : v.replace('PKR', '');
}

export function formatCurrencyShrink(amount: number) {
  if (typeof amount !== 'number') return amount;

  if (Math.abs(amount) >= 1e7) {
    return (amount / 1e7).toFixed(2) + ' Cr';
  } else if (Math.abs(amount) >= 1e5) {
    return (amount / 1e5).toFixed(2) + ' L';
  } else if (Math.abs(amount) >= 1e3) {
    return (amount / 1e3).toFixed(2) + ' K';
  } else {
    return amount.toFixed(2);
  }
}

export const parseLocalDate = (dateStr: string) => {
  const [year, month, day] = dateStr.split('-').map(Number);
  return new Date(year, month - 1, day);
};
